import React from "react";
import { useSelector } from "react-redux";
import {
	Toolbar as RhombusToolbar,
	Button
} from "rhombus-react";
import { Link } from "react-router-dom";

import Permissioned from "widgets/Permissioned";
import { SEARCH_DEBOUNCE } from "utils/constants";

export default function Toolbar({ searchTerm, handleSearch }){
	let routeLocation = useSelector(state => state?.router?.location?.pathname);

	const searchProps = {
		className:"cypress-creative-library-search",
	};
	return (
		<RhombusToolbar
			search
			searchDebounce={SEARCH_DEBOUNCE}
			onSearch={handleSearch}
			searchValue={searchTerm}
			searchProps={searchProps}
		>
			<div className="actions-side">
				<Permissioned
					domain = "Creative Library"
					action = "Create">
					<Link to={`${routeLocation}modal/new/`}>
						<Button style="block" theme="blue" icon="add">New Creative Library</Button>
					</Link>
				</Permissioned>
			</div>
		</RhombusToolbar>
	);
}

Toolbar.displayName = "LibraryToolbar";
